import type { FaireProductEntity } from "../../entity_types/product";

export const matcha_2: FaireProductEntity = {
  token: "matcha-2",
  type: "product",
  name: "Ceremonial Blend Matcha",
  brandName: "Matcha Freak",
  imageUrl:
    "https://cdn.prerelease.faire.dev/fastly/bf5aa74b57c0f65c898f8a3b6e60fc399ab56d18737b05c5065ba2b28b1c8bc2.png",
  priceDollars: 20,
  freeShipping: false,
  brandAvatarUrl:
    "https://cdn.prerelease.faire.dev/fastly/bf5aa74b57c0f65c898f8a3b6e60fc399ab56d18737b05c5065ba2b28b1c8bc2.png",
  weight: 0.2,
  dimensions: {
    width: 3,
    height: 5,
    depth: 2,
  },
  description: "Ceremonial blend matcha powder",
  categoryTokens: ["cat_food-beverages"],
  tags: ["matcha", "tea", "japanese-green-tea", "ceremonial", "premium"],
  inStock: true,
  meta: {
    source: "mock",
    importedAt: "2026-03-24T00:00:00.000Z",
    importedBy: "legacy-compass-migration",
  },
};
